import { useBudgetList } from 'app/components/location-settings-budget-list/useBudgetList'
import { BudgetListComponent } from 'app/components/location-settings-budget-list/BudgetListComponent'

export default function Budget() {
  const props = useBudgetList()
  return <BudgetListComponent {...props} />
}
